import { render, staticRenderFns } from "./AzimutReport.vue?vue&type=template&id=20ffc411&scoped=true&"
import script from "./AzimutReport.vue?vue&type=script&lang=js&"
export * from "./AzimutReport.vue?vue&type=script&lang=js&"
import style0 from "./AzimutReport.vue?vue&type=style&index=0&id=20ffc411&lang=scss&scoped=true&"
import style1 from "./AzimutReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ffc411",
  null
  
)

export default component.exports